<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>编辑轮播banner</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :model="bannerForm">
            <el-form-item label="上传banner图" label-width="100px">
                <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :show-file-list="false" :on-success="handleAvatarSuccess" :on-error="handleError" :before-upload="beforeAvatarUpload" :data="uptoken">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="跳转类型选择" label-width="100px">
                <el-radio-group v-model="bannerForm.type" @change="typeChange">
                    <el-radio label="0">商品类型</el-radio>
                    <el-radio label="2">商品</el-radio>
                    <el-radio label="1">商品标签</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="已选商品类型" label-width="100px" v-if="bannerForm.type === '0'">
                <el-input v-model="bannerForm.choosedName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="已选商品" label-width="100px" v-if="bannerForm.type === '2'">
                <el-input v-model="bannerForm.choosedName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="已选商品标签" label-width="100px" v-if="bannerForm.type === '1'">
                <el-input v-model="bannerForm.choosedName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label-width="100px">
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
        </el-form>


        <el-dialog title="选择分类" v-model="chooseCatogry">
            <el-form :model="cur_categroy">
                <el-form-item label="选择分类" label-width="100px">
                    <el-select v-model="cur_categroy.now" placeholder="分类">
                        <el-option v-for="item in categoryArr" v-if="item.isOnline" :key="item.categoryId" :label="item.name" :value="item.categoryId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseCatogry = false">取 消</el-button>
                <el-button type="primary" @click="catogryChoose">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="选择标签" v-model="chooseTopic">
            <el-form :model="cur_topic">
                <el-form-item label="选择标签" label-width="100px">
                    <el-select v-model="cur_topic.now" placeholder="标签">
                        <el-option v-for="item in topicArr" v-if="item.isOnline" :key="item.tagId" :label="item.name" :value="item.tagId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseTopic = false">取 消</el-button>
                <el-button type="primary" @click="topicChoose">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="选择商品" v-model="chooseProduct">
            <el-form :model="cur_product">
                <el-form-item label="选择商品" label-width="100px">
                    <el-select v-model="cur_product.now" placeholder="商品">
                        <el-option v-for="item in productArr" v-if="item.isOnline" :key="item.productDetailId" :label="item.name" :value="item.productDetailId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseProduct = false">取 消</el-button>
                <el-button type="primary" @click="productChoose">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getVersions,
        getGlobalSettings,
        filterIndexVersions,
        getProductCategories,
        getProductTags,
        getProductDetails
    } from '../../api/version'

    export default {
        data() {
            return {
                bannerForm: {
                    type: '',
                    choosedName: ''
                },
                choosedName: '',
                imageUrl: '',
                upImage: '',
                type: '',
                targetId: '',
                uptoken: {
                    token: sessionStorage.token
                },
                categoryArr: [],
                topicArr: [],
                productArr: [],
                chooseCatogry: false,
                chooseTopic: false,
                chooseProduct: false,
                cur_categroy: {
                    now: ''
                },
                cur_topic: {
                    now: ''
                },
                cur_product: {
                    now: ''
                }
            }
        },
        created() {
            this.productArr = this.$store.state.topicArr
            this.categoryArr = this.$store.state.categoryArr
            this.topicArr = this.$store.state.productArr
            let currentData = ''
            this.$store.state.currentIndex.value.banner.forEach( item => {
                if(item.targetId === this.$route.params.id*1) {
                    currentData = item
                }
            })

            this.upImage = currentData.picUrl
            this.imageUrl = currentData.picUrl
            this.type = currentData.type
            this.targetId = currentData.targetId

            this.bannerForm = {
                picUrl: currentData.picUrl,
                type: currentData.type + '',
                targetId: currentData.targetId + ''
            }

            if (currentData.type == 0) {
                this.cur_categroy = {
                    now: currentData.targetId
                }
                this.categoryArr.forEach(item2 => {
                    if (item2.categoryId === currentData.targetId) {
                        this.bannerForm.choosedName = item2.name
                    }
                })
            } else if (currentData.type == 1) {
                this.cur_topic = {
                    now: currentData.targetId
                }
                this.topicArr.forEach(item2 => {
                    if (item2.tagId === currentData.targetId) {
                        this.bannerForm.choosedName = item2.name
                    }
                })
            } else {
                this.cur_product = {
                    now: currentData.targetId
                }
                this.productArr.forEach(item2 => {
                    if (item2.productDetailId === currentData.targetId) {
                        this.bannerForm.choosedName = item2.name
                    }
                })
            }
        },
    methods: {
        onSubmit() {
            let bannerData = {
                'picUrl': this.upImage,
                'type': this.type*1,
                'targetId': this.targetId
            }
            console.log(bannerData)
            let currentData = this.$store.state.currentIndex
            let index = this.$route.params.id*1
            currentData.value.banner.forEach( (item,i) => {
                if(item.targetId === index) {
                    currentData.value.banner.splice(i,1,bannerData)
                }
            })

            console.log(currentData,'dd')
            this.$store.commit('SETCURRENTINDEX', currentData);
            this.$message({
                message: '编辑成功',
                type: 'success'
            });
            this.$router.push('/banner')


        },
        goBack() {
            //取消
            this.$router.push('/banner')
        },
        typeChange(val) {
            // banner的类型	0:分类，1:标签, 2:商品
            if (val === '0') {
                this.type = '0'
                this.chooseCatogry = true
            } else if (val === '2') {
                this.type = '2'
                this.chooseProduct = true
            } else {
                this.type = '1'
                this.chooseTopic = true
            }
        },
        handleAvatarSuccess(res, file) {
            this.upImage = `https://img.shareplay.cc/${res.key}`
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            this.uptoken = {
                token: sessionStorage.token
            }

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        productChoose() {
            this.targetId = this.cur_product.now
            this.productArr.forEach(item => {
                if (item.productDetailId === this.targetId) {
                    this.bannerForm.choosedName = item.name
                }
            })
            this.chooseProduct = false
        },
        topicChoose() {
            this.targetId = this.cur_topic.now
            this.topicArr.forEach(item => {
                if (item.tagId === this.targetId) {
                    this.bannerForm.choosedName = item.name
                }
            })
            this.chooseTopic = false
        },
        handleError() {
            this.$message.error('请重新登录')
            this.$router.push('/login')
        },
        catogryChoose() {
            this.targetId = this.cur_categroy.now
            this.categoryArr.forEach(item => {
                if (item.categoryId === this.targetId) {
                    this.bannerForm.choosedName = item.name
                }
            })
            this.chooseCatogry = false
        }
    }
    }
</script>

<style>
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// EditBanner.vue?14cbb1fb